<template>
  <v-container>
    <v-row><h2>Thumbs</h2></v-row>
    <v-row>
      <v-col class="d-flex" cols="12" sm="4" v-for="model in models" :key="model.key">
        <v-card style="width: 100%">
          <v-card-title>{{ model.key }} - {{ sizes[model.key] }}</v-card-title>
          <v-card-text>
            <img v-if="model.path" :src="getUrl(model.path)" style="width: 100%;" alt="thumb" />
          </v-card-text>
          <v-card-actions class="d-flex">
            <v-text-field
              :label="model.key"
              :ref="model.key"
              v-model="model.path"
              disabled>
            </v-text-field>
            <v-file-input
              :label="getLabel(model.key)"
              accept="image/*"
              hide-input
              @change="(file) => uploadFor(model, file)">
            </v-file-input>
            <v-icon class="mt-4" @click="() => deleteThumb(model)">mdi-trash-can</v-icon>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {ClearCacheService} from '@/services/ClearCacheService';

export default {
  name: 'Thumbs',
  props: ['game', 'thumbs', 'metaId'],
  components: {},
  data: function () {
    return {
      sizes: {
        promoThumbPath: '1080x400',
        thumbPath: '600x600',
        secondaryThumbPath: '600x277',
      },
      models: [],
      keys: [],
    };
  },
  watch: {
    thumbs: function () {
      this.models = this.keys.map((key) => {
        const existing = this.thumbs?.find(t => t.key === key);
        return existing || {key, path: ''};
      });
    }
  },
  created: async function () {
    this.keys = await this.$gameApi.get('/dictionary/thumbs');
    this.models = this.keys.map((key) => {
      const existing = this.thumbs?.find(t => t.key === key);
      return existing || {key, path: ''};
    });
  },
  methods: {
    uploadFor: async function (model, file) {
      const formData = new FormData();
      formData.set('file', file);
      model.path = await this.$gameApi.post(`/games/${this.game.id}/metas/${this.metaId}/thumbs/${model.key}`, formData);

      await ClearCacheService.clearCacheByItems([model.path.path], 'Url', 'Delete');

      this.$emit('change');
    },
    getLabel(key) {
      const size = this.sizes[key];
      return key + ' ' + (size ? '(' + size + ')' : '');
    },
    getUrl(path) {
      // https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-games/MahjonggCandy/1.7//assets/thumbs/thumb2x.jpg
      const result = path?.startsWith('http')
        ? path
        : `https://arenacloud.cdn.arkadiumhosted.com/arenaxstorage-blob/arenax-games/${this.game?.sdkName || this.game?.slug}/${this.game?.versions[0]?.version}/${path}`;

      return result + `?ark__v=${new Date().getTime()}`
    },
    async deleteThumb(model) {
      await this.$gameApi.delete(`/games/${this.game.id}/metas/${this.metaId}/thumbs/${model.id}`);
      model.path = ""
    }
  },
};
</script>
